// Component based on https://walkingriver.com/custom-angular-checkbox/
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, NgModule, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lp2-checkbox',
  template: `
    <label class="cb-container" [ngClass]="{'disabled' : disabled, 'secondary': color === 'secondary', 'small-size': size === 'small' }">
      <input type="checkbox" [checked]="isChecked" (change)="onChanged($event)" (blur)="onBlur($event)" [disabled]="disabled"/>
      <span class="checkmark"></span>
      <span class="label" [ngClass]="{ labelChecked: isChecked }">{{ label }}</span>
    </label>
  `,
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() set checked(value: boolean) {
    this.isChecked = value;
  }
  @Input() disabled = false;
  @Input() color: 'primary' | 'secondary' = 'primary';
  @Input() size: 'small' | 'medium' = 'medium';
  @Output() valueChanges = new EventEmitter<boolean>();

  isChecked = false;
  onChange = (_) => { };
  onBlur = (_) => { };

  writeValue(obj: boolean): void {
    this.isChecked = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onBlur = fn;
  }


  onChanged($event) {
    this.isChecked = $event && $event.target && $event.target.checked;
    this.onChange(this.isChecked);
    this.valueChanges.emit(this.isChecked);
  }
}

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [CheckboxComponent],
  exports: [CheckboxComponent],
})
export class CheckboxModule { }



// WEBPACK FOOTER //
// ./ts/app/components/checkbox/checkbox.component.ts